import React, { lazy } from 'react';
import { motion } from 'framer-motion';
// Custom brand SVG icons for the
function IconHome() {
  return <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
    backgroundColor: 'rgba(139,94,60,0.12)'
  }} data-id="element-262">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" data-id="element-263">
        <path d="M3 10.5L12 3L21 10.5V20C21 20.55 20.55 21 20 21H15V15H9V21H4C3.45 21 3 20.55 3 20V10.5Z" fill="#e76f51" data-id="element-264" />
        <path d="M12 3L3 10.5H21L12 3Z" fill="#8B5E3C" data-id="element-265" />
        <rect x="10" y="11" width="4" height="4" rx="0.5" fill="#F5EDE4" data-id="element-266" />
      </svg>
    </div>;
}
function IconBrand() {
  return <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
    backgroundColor: 'rgba(139,94,60,0.12)'
  }} data-id="element-267">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" data-id="element-268">
        <circle cx="12" cy="12" r="8" fill="#D4C4B0" data-id="element-269" />
        <path d="M12 4C12 4 8 8 8 12C8 16 12 20 12 20C12 20 16 16 16 12C16 8 12 4 12 4Z" fill="#8B5E3C" data-id="element-270" />
        <circle cx="12" cy="12" r="3" fill="#e76f51" data-id="element-271" />
        <circle cx="12" cy="12" r="1.2" fill="#F5EDE4" data-id="element-272" />
      </svg>
    </div>;
}
function IconSocial() {
  return <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
    backgroundColor: 'rgba(231,111,81,0.12)'
  }} data-id="element-273">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" data-id="element-274">
        <rect x="5" y="3" width="14" height="18" rx="3" fill="#1A1614" data-id="element-275" />
        <rect x="6.5" y="5" width="11" height="12" rx="1" fill="#F5EDE4" data-id="element-276" />
        <circle cx="12" cy="19" r="1" fill="#D4C4B0" data-id="element-277" />
        <circle cx="12" cy="11" r="3" fill="#e76f51" opacity="0.9" data-id="element-278" />
        <path d="M10.5 10L14 11L10.5 12V10Z" fill="#F5EDE4" data-id="element-279" />
      </svg>
    </div>;
}
function IconPricing() {
  return <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
    backgroundColor: 'rgba(139,94,60,0.12)'
  }} data-id="element-280">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" data-id="element-281">
        <path d="M4 7C4 5.9 4.9 5 6 5H18C19.1 5 20 5.9 20 7V17C20 18.1 19.1 19 18 19H6C4.9 19 4 18.1 4 17V7Z" fill="#8B5E3C" data-id="element-282" />
        <rect x="4" y="9" width="16" height="3" fill="#e76f51" data-id="element-283" />
        <circle cx="16" cy="15.5" r="1.5" fill="#D4C4B0" data-id="element-284" />
        <circle cx="13" cy="15.5" r="1.5" fill="#D4C4B0" opacity="0.5" data-id="element-285" />
      </svg>
    </div>;
}
function IconStructure() {
  return <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
    backgroundColor: 'rgba(231,111,81,0.12)'
  }} data-id="element-286">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" data-id="element-287">
        <rect x="4" y="4" width="7" height="7" rx="1.5" fill="#e76f51" data-id="element-288" />
        <rect x="13" y="4" width="7" height="7" rx="1.5" fill="#D4C4B0" data-id="element-289" />
        <rect x="4" y="13" width="7" height="7" rx="1.5" fill="#D4C4B0" data-id="element-290" />
        <rect x="13" y="13" width="7" height="7" rx="1.5" fill="#8B5E3C" data-id="element-291" />
        <path d="M8 8L16 16M16 8L8 16" stroke="#F5EDE4" strokeWidth="1.5" strokeLinecap="round" data-id="element-292" />
      </svg>
    </div>;
}
export function ProductIntro() {
  return <>
      {/* LA VERDAD QUE CASI NADIE EXPLICA */}
      <section className="py-24 md:py-32 px-4" style={{
      backgroundColor: '#ffffff'
    }} data-id="element-293">
        <div className="max-w-4xl mx-auto" data-id="element-294">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.6
        }} data-id="element-295">
            <span className="text-sm font-bold tracking-[0.2em] uppercase mb-4 inline-block" style={{
            color: '#e76f51'
          }} data-id="element-296">
              🔐 LA VERDAD
            </span>
            <h2 className="text-4xl md:text-5xl font-bold mb-10" style={{
            color: '#1A1614'
          }} data-id="element-297">
              Lo que casi nadie explica
            </h2>

            <p className="text-xl mb-10" style={{
            color: '#5a5248'
          }} data-id="element-298">
              Los cinnamon rolls XL estilo bakery viral no son solo más grandes.
            </p>

            <p className="text-2xl font-bold mb-8" style={{
            color: '#1A1614'
          }} data-id="element-299">
              Tienen 4 pilares invisibles:
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-300">
              {[{
              num: '1',
              text: 'Masa estructurada para altura real',
              img: 'https://cdn.magicpatterns.com/uploads/55en61MHMZ2sGYK6HiGT6J/ChatGPT_Image_27_mar_2026,_10_25_25_p.m..png'
            }, {
              num: '2',
              text: 'Capas gruesas visibles',
              img: 'https://cdn.magicpatterns.com/uploads/xiF9976qQ6Gba1j43hNu2f/467772843_18277633798217385_4043785765112933198_n.jpg'
            }, {
              num: '3',
              text: 'Rellenos abundantes sin dañar textura',
              img: 'https://cdn.magicpatterns.com/uploads/sNT8TUWPFEDNSJds2Tsbn5/KlQPRApjTMKsF-nWBiX_e.png'
            }, {
              num: '4',
              text: 'Presentación estratégica tipo vitrina moderna',
              img: 'https://cdn.magicpatterns.com/uploads/7sYqtXYHHA2HBUBrytzg6J/ChatGPT_Image_27_mar_2026,_10_21_43_p.m..png'
            }].map((item, i) => <div key={i} className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden flex items-stretch" data-id="element-301">
                  <div className="flex-1 p-5 md:p-6 flex items-start gap-4" data-id="element-302">
                    <div className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 font-bold text-base" style={{
                  backgroundColor: '#e76f51',
                  color: '#ffffff'
                }} data-id="element-303">
                      {item.num}
                    </div>
                    <p className="text-base md:text-lg font-medium" style={{
                  color: '#1A1614'
                }} data-id="element-304">
                      {item.text}
                    </p>
                  </div>
                  <img src={item.img} alt={item.text} loading="lazy" decoding="async" className="w-20 h-20 md:w-24 md:h-24 object-cover flex-shrink-0" data-id="element-305" />
                </div>)}
            </div>

            <div className="bg-gray-50 rounded-3xl p-8 md:p-10 border border-gray-100" data-id="element-306">
              <p className="text-xl font-bold mb-4" style={{
              color: '#1A1614'
            }} data-id="element-307">
                Sin esos 4 pilares…
              </p>
              <div className="space-y-3 mb-6" data-id="element-308">
                {['Lo XL se aplasta.', 'Se seca.', 'Pierde forma.'].map((item, i) => <div key={i} className="flex items-center gap-3 text-lg" style={{
                color: '#5a5248'
              }} data-id="element-309">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="flex-shrink-0" data-id="element-310">
                        <circle cx="10" cy="10" r="10" fill="#e76f51" opacity="0.12" data-id="element-311" />
                        <path d="M6.5 6.5L13.5 13.5M13.5 6.5L6.5 13.5" stroke="#e76f51" strokeWidth="2" strokeLinecap="round" data-id="element-312" />
                      </svg>
                      <span data-id="element-313">{item}</span>
                    </div>)}
              </div>
              <p className="text-xl font-bold" style={{
              color: '#e76f51'
            }} data-id="element-314">
                Y eso casi nadie lo enseña correctamente.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ¿TE SUENA FAMILIAR? */}
      <section className="py-24 md:py-32 px-4 pt-[50px] pb-[50px]" style={{
      backgroundColor: '#F5EDE4'
    }} data-id="element-315">
        <div className="max-w-4xl mx-auto" data-id="element-316">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.6
        }} data-id="element-317">
            <span className="text-sm font-bold tracking-[0.2em] uppercase mb-4 inline-block" style={{
            color: '#e76f51'
          }} data-id="element-318">
              🔍 ¿TE SUENA FAMILIAR?
            </span>
            <h2 className="text-4xl md:text-5xl font-bold mb-4" style={{
            color: '#1A1614'
          }} data-id="element-319">
              Tal vez te ha pasado:
            </h2>

            <div className="space-y-5 mt-10 mb-12" data-id="element-320">
              {[{
              emojiImg: 'https://cdn.magicpatterns.com/uploads/vkrH9xV9dqCbUsgwNLEjzh/tired-face_1f62b.png',
              text: 'Quieres empezar algo desde casa, pero no sabes qué producto realmente vale la pena.'
            }, {
              emojiImg: 'https://cdn.magicpatterns.com/uploads/h8kbF2AB1FkEvjFCEbnGfV/Diseno_sin_titulo_(3).png',
              text: 'Haces postres, pero no parecen "de marca".'
            }, {
              emojiImg: 'https://cdn.magicpatterns.com/uploads/wSBf3yYHnQVS8NHsbxtjxP/mobile-phone-with-rightwards-arrow-at-left_1f4f2.png',
              text: 'Ves cuentas en redes que venden todo… y no entiendes qué están haciendo diferente.'
            }, {
              emojiImg: 'https://cdn.magicpatterns.com/uploads/muD2pkp29FgWNzLdnoyhzK/money-bundle-3d-graphic-illustration-png.png',
              text: 'Te gustaría subir precios… pero sientes que no puedes.'
            }, {
              emojiImg: 'https://cdn.magicpatterns.com/uploads/3hBLV3y9bwJxeDkmSjYJme/cupcake_1f9c1.png',
              text: 'Tienes ganas, pero no estructura.'
            }].map((item, i) => <div key={i} className="flex items-center gap-5 bg-white rounded-2xl p-6 shadow-sm border border-gray-100" data-id="element-321">
                  <div className="w-14 h-14 rounded-2xl flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: 'rgba(231,111,81,0.08)'
              }} data-id="element-322">
                    {'emojiImg' in item ? <img src={item.emojiImg} alt="" loading="lazy" decoding="async" className="w-8 h-8 object-contain" data-id="element-323" /> : <span className="text-2xl" data-id="element-324">{item.emoji}</span>}
                  </div>
                  <p className="text-lg" style={{
                color: '#1A1614'
              }} data-id="element-325">
                    {item.text}
                  </p>
                </div>)}
            </div>

            <div className="text-center space-y-4 py-8" data-id="element-326">
              <p className="text-xl italic" style={{
              color: '#5a5248'
            }} data-id="element-327">
                Y lo más fuerte…
              </p>
              <p className="font-bold text-[24px]" style={{
              color: '#1A1614'
            }} data-id="element-328">
                Sientes que podrías hacer algo grande… pero no sabes cómo
                llevarlo ahí.
              </p>
              <p className="text-xl" style={{
              color: '#5a5248'
            }} data-id="element-329">
                Eso pesa.
              </p>
              <p className="text-xl" style={{
              color: '#5a5248'
            }} data-id="element-330">
                Porque no es falta de talento.
              </p>
              <p className="text-3xl font-bold" style={{
              color: '#e76f51'
            }} data-id="element-331">
                Es falta de sistema.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </>;
}